import React, { JSX } from 'react';
import { AppBar, Box, Dialog, IconButton, Slide, Toolbar, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Resume } from 'types/types';
import { ResumeDetails } from './ResumeViewerDetails';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function ResumeMobileDialog(props: {
  open: boolean;
  selectedResume: Resume | null;
  onClose: () => void;
}): JSX.Element {
  return (
    <Dialog
      fullScreen
      open={props.open}
      onClose={props.onClose}
      TransitionComponent={Transition}
      TransitionProps={{ timeout: 300 }}
    >
      <AppBar sx={{ position: 'relative', elevation: 1 }}>
        <Toolbar variant="dense" sx={{ minHeight: 48 }}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={props.onClose}
            aria-label="back"
            size="small"
          >
            <ArrowBackIcon />
          </IconButton>
          <Box sx={{ ml: 1, flex: 1, minWidth: 0 }}>
            <Typography variant="h6" component="div" noWrap sx={{ fontSize: '1rem' }}>
              Resume Details
            </Typography>
            <Typography
              variant="caption"
              component="div"
              sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
              noWrap
            >
              {props.selectedResume?.candidate?.fullName || props.selectedResume?.candidateId}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <ResumeDetails selectedResume={props.selectedResume} inDialog />
    </Dialog>
  );
}
